module.exports = {
  admin      : require './admin'
  track      : require './track'
  hull       : require './hull'
  angellist  : require './angellist'
  facebook   : require './facebook'
  github     : require './github'
  google     : require './google'
  instagram  : require './instagram'
  linkedin   : require './linkedin'
  soundcloud : require './soundcloud'
  tumblr     : require './tumblr'
  twitter    : require './twitter'
}



/** WEBPACK FOOTER **
 ** ./src/remote/services/list.coffee
 **/